import { useTranslation } from "react-i18next";
import qrIcon from "../../images/icons/qrcode.svg";
import fileIcon from "../../images/icons/file.svg";
import giftIcon from "../../images/icons/gift.svg";

const Features = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: qrIcon,
      title: t("features.scan_qr.title"),
      description: t("features.scan_qr.description"),
    },
    {
      icon: fileIcon,
      title: t("features.digital_storage.title"),
      description: t("features.digital_storage.description"),
    },
    {
      icon: giftIcon,
      title: t("features.rewards.title"),
      description: t("features.rewards.description"),
    },
  ];

  return (
    <section id="features" className="bg-surface">
      <div className="container mx-auto py-32 flex flex-col justify-center items-center gap-14">
        <h1 className="flex flex-col sm:flex-row gap-2 text-black text-4xl font-bold text-center px-8 md:px-0">
          {t("features.title")}{" "}
          <span className="text-primaryDark">{t("features.subtitle")}</span>
        </h1>

        <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-6 px-4 lg:px-20">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group relative border border-grayDark rounded-20 px-5 py-9 
             bg-white transition-all duration-500 ease-out 
             hover:-translate-y-3 hover:scale-105 hover:shadow-2xl"
            >
              <div
                className="absolute inset-0 rounded-20 opacity-0 group-hover:opacity-100 
                  transition-opacity duration-500 
                  bg-gradient-to-tr from-primaryDark/20 to-white blur-xl"
              />

              <img
                src={feature.icon}
                alt={feature.title}
                className="transition-transform duration-500 group-hover:-translate-y-2 group-hover:rotate-6 relative z-10"
              />

              <p
                className="text-black text-xl font-bold my-5
                relative z-10 transition-all duration-500 group-hover:text-primaryDark group-hover:tracking-wider"
              >
                {feature.title}
              </p>

              <p
                className="text-grayDark relative z-10 transition-all duration-500 
                group-hover:text-black group-hover:translate-y-1"
              >
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
